export default __webpack_public_path__ + "static/media/2.5481af41.jpg";